import { Session } from "../../../types/working-model";
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import TabHeader from '../../general-ui/tab-header/tab-header';
import { useEffect, useState } from 'react';
import SelectInput from '../../general-ui/select/select';
import { batch, useDispatch } from 'react-redux';
import SessionList from './session-list';
import RegistrationsList from './registrations-list';
import {
	getEventRegistrationsCount,
	updateEventRegistrationsSearch,
} from '../../../store/actions/admin/people';
import { useSelector } from 'react-redux';
import { EventsState } from '../../../store/types';
import Search from '../../general-ui/search-bar/search';

const sortByOptions = [
	{
		label: "Newest",
		value: "newest"
	},
	{
		label: "Oldest",
		value: "oldest"
	},
	{
		label: "A-Z",
		value: "a-z"
	},
	{
		label: "Z-A",
		value: "z-a"
	}
];

export default function EventDetails(): JSX.Element {

	const {
		CreateEventReducer: { selectedEvent },
		AuthReducer: { user, token }
	} = useSelector((state: EventsState) => state);

	const dispatch = useDispatch();

	const [activeTab, setActiveTab] = useState(`Sessions`);
	const [sessions, setSessions] = useState<Session[]>([]);
	const [sortBy, setSortBy] = useState("");
	const [/* isLive */, setIsLive] = useState(false);

	useEffect(() => {
		if (selectedEvent) {
			batch(() => {
				dispatch(updateEventRegistrationsSearch(''));
				dispatch(getEventRegistrationsCount(token!, user!.active_channel, '', selectedEvent!.event!));
			});
			setSessions(selectedEvent.sessions.map((session: Session) => {
				return session;
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedEvent]);

	const handleSearch = (search: string) => {
		switch (activeTab) {
			case "Sessions": {
				const array: Session[] | undefined = selectedEvent?.sessions.filter((session: Session) => {
					return session.title.base.toLowerCase().includes(search.toLowerCase());
				});
				return setSessions(array!);
			}
			case "Registered People": {
				batch(() => {
					dispatch(updateEventRegistrationsSearch(search));
					dispatch(getEventRegistrationsCount(token!, user!.active_channel, search, selectedEvent!.event!));
				});
				return;
			}
			default: return;
		}
	};

	const handleClear = () => {
		switch (activeTab) {
			case "Sessions": {
				if (selectedEvent) {
					setSessions(selectedEvent.sessions.map((session: Session) => {
						return session;
					}));
				}
				return;
			}
			case "Registered People": {
				batch(() => {
					dispatch(getEventRegistrationsCount(token!, user!.active_channel, '', selectedEvent!.event!));
					dispatch(updateEventRegistrationsSearch(''));
				});
				return;
			}
			default: return;
		}
	};

	const checkEmptySearch = (search: string) => {
		if (search === '') {
			handleClear();
		}
	};


	function handleSortByChange(value: string) {
		if (selectedEvent) {
			setSortBy(value);
			switch (value) {
				case "newest": {
					const array: Session[] = selectedEvent.sessions.sort((a, b) => {
						if (a.timestamp && b.timestamp) {
							const timeA = new Date(a.timestamp!);
							const timeB = new Date(b.timestamp!);

							return timeA > timeB ? -1 : 1;
						} else { return -1; }
					});
					return setSessions(array);
				}
				case "oldest": {
					const array: Session[] = selectedEvent.sessions.sort((a, b) => {
						if (a.timestamp && b.timestamp) {
							const timeA = new Date(a.timestamp!);
							const timeB = new Date(b.timestamp!);

							return timeA < timeB ? -1 : 1;
						} else { return -1; }
					});
					return setSessions(array);
				}
				case "a-z": {
					const array: Session[] = selectedEvent.sessions.sort((a, b) => {
						if (a.title.base && b.title.base) {
							const nameA = a.title.base;
							const nameB = b.title.base;

							return nameA < nameB ? -1 : 1;
						} else { return -1; }
					});
					return setSessions(array);
				}
				case "z-a": {
					const array: Session[] = selectedEvent.sessions.sort((a, b) => {
						if (a.title.base && b.title.base) {
							const nameA = a.title.base;
							const nameB = b.title.base;

							return nameA > nameB ? -1 : 1;
						} else { return -1; }
					});
					return setSessions(array);
				}
				default: return;
			}
		}
	}

	useEffect(() => {
		if (selectedEvent) {
			const date = Date.now();
			selectedEvent.sessions.map((session: Session) => {
				const timestamp = new Date(session.timestamp!);
				const end_timestamp = new Date(session.end_timestamp!);
				const start = timestamp.getTime();
				const end = end_timestamp.getTime();
				if (start < date && end > date) {
					setIsLive(true);
				}
			});
		}
	}, [selectedEvent]);

	return (
		<div className="event-details-container">
			<div className="tab-wrapper">
				<div className="tab-container">
					<div className="tab-header">
						<TabHeader tabs={[`Sessions`, `Registered People`]} onClick={setActiveTab} currentTab={activeTab} />
					</div>
				</div>
				<div className={"search-container"}>
					<div>
						<Search
							onSearch={handleSearch}
							onClear={handleClear}
							onChange={checkEmptySearch}
						/>
					</div>
					{activeTab === `Sessions` ? (
						<div className="sort-container">
							<SelectInput
								placeholder="Sort by"
								mainIcon={<Icon name={ICONS.KEYBOARD_ARROW_DOWN} size={14} color={COLORS.WHITE} />}
								options={sortByOptions}
								selected={sortBy}
								small
								noMaxHeight
								onChange={handleSortByChange}
							/>
						</div>
					) : (
						<></>
					)}
				</div>
			</div>
			{activeTab === `Sessions` ? (
				<SessionList sessionList={sessions} selectedEvent={selectedEvent!} />
			) : (
				<>
					{activeTab === `Registered People` ? (
						<RegistrationsList selectedEvent={selectedEvent!} />
					) : (
						<></>
					)}
				</>
			)}
		</div>
	);
}